import * as React from 'react';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import * as Device from 'react-device-detect';

import AccountMenu from './menu/AccountMenu';
import ActivateReminder from './menu/ActivateReminder';
import AccountChange from './menu/AccountChange';
import AddAccount from './menu/AddAccount';
import AccountSettings from './menu/AccountSettings';
import NotificationSettings from './menu/NotificationSettings';
import UserSettings from './menu/UserSettings';
import LogoutButton from './menu/LogoutButton';

interface AccountDrawerProps {
  handleOpenDialog: (event: React.MouseEvent<HTMLElement>) => void;
  handleCloseDrawer: () => void;
}

export function AccountDrawer(props: Readonly<AccountDrawerProps>) {
  const { handleOpenDialog, handleCloseDrawer } = props;
  const theme = useTheme();
  const listItemColor = Device.isMobile ? 'primary' : 'secondary';

  return (
    <Box
      sx={{
        width: 300,
        color: theme.palette.text[listItemColor],
        '& .MuiListItemButton-root': {
          color: theme.palette.text[listItemColor],
          '& .MuiListItemIcon-root, & .MuiListItemText-root': {
            color: theme.palette.text[listItemColor],
          },
          '&:hover': {
            color: theme.palette.text.primary,
            '& .MuiListItemIcon-root, & .MuiListItemText-root': {
              color: theme.palette.text.primary,
            },
          },
        },
        '& .MuiDivider-root': {
          backgroundColor: theme.palette.grey[700],
        },
      }}
      role="presentation"
    >
      <List>
        <AccountMenu />
        <ActivateReminder />
        <Divider sx={{ backgroundColor: theme.palette.grey[700] }} variant="middle" />
        <AccountChange />
        <AccountSettings handleOpenDialog={handleOpenDialog} />
        <NotificationSettings handleOpenDialog={handleOpenDialog} />
        <UserSettings handleOpenDialog={handleOpenDialog} />
      </List>
      <Divider sx={{ backgroundColor: theme.palette.grey[700] }} variant="middle" />
      <List>
        <AddAccount handleCloseDrawer={handleCloseDrawer} />
      </List>
      <Divider sx={{ backgroundColor: theme.palette.grey[700] }} variant="middle" />
      <List>
        <LogoutButton />
      </List>
    </Box>
  );
}
